// Keep controls above the overlay that contains their trigger.
export const textAssetPopupContainer = trigger => trigger.closest('.ant-drawer-body') || trigger.closest('#asset-modal') || trigger.parentElement;
